(() => {
  if (customElements.get('giesto-back-to-top')) return;

  // Show after about one and a half screens of scrolling; a short page never reaches it.
  const SHOW_AFTER_SCREENS = 1.5;

  class GiestoBackToTop extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = /** @type {HTMLButtonElement | null} */ (this.querySelector('.gtt__button'));
      if (!this.button) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const passive = { signal: this.controller.signal, passive: true };
      this.frame = 0;
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      // Desktop (>=990px) scrolls .page-wrapper instead of the document; listen to both.
      this.wrapper = document.querySelector('.page-wrapper');
      window.addEventListener('scroll', schedule, passive);
      this.wrapper?.addEventListener('scroll', schedule, passive);
      window.addEventListener('resize', schedule, passive);
      this.button.addEventListener('click', (event) => this.toTop(event.detail === 0), options);
      this.update();
    }

    scroller() {
      const wrapper = this.wrapper;
      if (wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) && wrapper.scrollHeight > wrapper.clientHeight) {
        return wrapper;
      }
      return document.scrollingElement ?? document.documentElement;
    }

    update() {
      const visible = this.scroller().scrollTop > window.innerHeight * SHOW_AFTER_SCREENS;
      this.button.classList.toggle('is-visible', visible);
    }

    toTop(fromKeyboard) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scroller().scrollTo({ top: 0, behavior: reduce ? 'instant' : 'smooth' });
      // The button disappears at the top, so keyboard focus moves to the start of the page.
      if (!fromKeyboard) return;
      const start = /** @type {HTMLElement | null} */ (document.querySelector('.skip-to-content-link'));
      if (start) {
        start.focus({ preventScroll: true });
      } else {
        document.body.setAttribute('tabindex', '-1');
        document.body.focus({ preventScroll: true });
        document.body.addEventListener('blur', () => document.body.removeAttribute('tabindex'), { once: true });
      }
    }

    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('giesto-back-to-top', GiestoBackToTop);
})();
